module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/3rd-87e63c5e9edd5d9e.png"+" 96w",
        images: [{path: __webpack_public_path__ + "assets/images/3rd-87e63c5e9edd5d9e.png",width: 96,height: 96}],
        src: __webpack_public_path__ + "assets/images/3rd-87e63c5e9edd5d9e.png",
        toString: function(){return __webpack_public_path__ + "assets/images/3rd-87e63c5e9edd5d9e.png"},
        
        width: 96,
        height: 96
      }